import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const PreCoolingForm = (props) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});
  const [rangeClose, setRangeClose] = useState(false);
  const [employeeId, setEmployeeId] = useState();
  const [palletNo, setPalletNo] = useState();

  const { sendRequest: postPreCooling } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getPalletNo } = useHttp();

  useEffect(() => {
    getPalletNo(
      {
        url: `/api/palletizationForPreCooling/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (data) => {
        // //console.log(data);
        setPalletNo(data.Palletization);
      }
    );
  }, [getPalletNo]);

  const { sendRequest: getPalletProduct } = useHttp();

  const [palletProduct, setPalletProduct] = useState();

  const handlePalletNoChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
    if (id) {
      getPalletProduct(
        {
          url: `/api/palletizationProductDetail/?palletizationId=${id}`,
        },
        (data) => {
          //console.log(data);
          setPalletProduct(data.Palletization);
        }
      );
    }
  };

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      preCoolingDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      startTime: frmRef.current.start_time.value,
      endTime: frmRef.current.end_time.value,
      preCoolingMethod: frmRef.current.pre_cooling_method.value,
      initialTemperature: frmRef.current.initial_temp.value,
      finalTemperature: frmRef.current.final_temp.value,
      palletizationId: frmRef.current.pallet_no.value,

      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["preCoolingId"] = props.update.preCoolingId;
    }

    //console.log(data);
    postPreCooling(
      {
        url: "/api/pre-Cooling/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success("Pre-Coolong done successfully");

        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);

    if (props.update) {
      frmRef.current.date.value = moment(props.update.preCoolingDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      // frmRef.current.time_stamp.value = moment(
      //   props.update.timeStamp,
      //   "HH:mm"
      // ).format("hh:mm");

      frmRef.current.pre_cooling_method.value = props.update.preCoolingMethod;

      frmRef.current.remark.value = props.update.remark;
      // frmRef.current.temp.value = props.update.temperature;
    }
  }, [props.update]);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  return (
    <>
      {rangeClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setRangeClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <table className="table table-bordered table-sm">
            <thead>
              <tr className="tableheaderrowview">
                <th>Pallet No</th>
                <th>Item Quality)</th>
                <th>Product Cost</th>
              </tr>
            </thead>
            <tbody>
              {palletProduct &&
                palletProduct.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.palletNo}</td>
                      <td>{itm.itemQuantity}</td>
                      <td>{itm.productCost}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setRangeClose(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Pre Cooling Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x, i) => (
                            <option value={x.empId} key={i}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"start_time"}>{"Start Time"}</label>
                      <input
                        type={"time"}
                        id={"start_time"}
                        defaultValue={getCurrentTime()}
                        required
                        ref={(el) => (frmRef.current["start_time"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"end_time"}>{"End Time"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        defaultValue={getCurrentTime()}
                        required
                        ref={(el) => (frmRef.current["end_time"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"pallet_no"}>{"Palletization No"}</label>
                      <select
                        id="pallet_no"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["pallet_no"] = el)}
                        onChange={handlePalletNoChange}
                        required
                      >
                        <option value="">Select</option>
                        {palletNo &&
                          palletNo.map((x) => (
                            <option value={x.palletizationId}>
                              {x.palletizationNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"packed_item_id_range"}>
                        {"Pallet id Range"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"packed_item_id_range"}
                        autoComplete="off"
                        ref={(el) =>
                          (frmRef.current["packed_item_id_range"] = el)
                        }
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setRangeClose(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"pre_cooling_method"}>
                        {" "}
                        {"Pre-Cooling Method"}
                      </label>
                      <select
                        id="pre_cooling_method"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["pre_cooling_method"] = el)
                        }
                      >
                        <option value="Room Cooling">Room Cooling</option>
                        <option value="Forced Air-Cooling">
                          Forced Air-Cooling
                        </option>
                        <option value="Ice Cooling">Ice Cooling</option>
                        <option value="Vacuum Cooling">Vacuum Cooling</option>
                        <option value="Zero Energy Cool Chamber(ZECC)">
                          Zero Energy Cool Chamber(ZECC)
                        </option>
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"temp"}>
                        {" "}
                        {"Initial Temperature(°C)"}
                      </label>
                      <input
                        type={"text"}
                        id={"initial_temp"}
                        required
                        ref={(el) => (frmRef.current["initial_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"temp"}>
                        {" "}
                        {"Final Temperature (°C)  "}
                      </label>
                      <input
                        type={"text"}
                        id={"final_temp"}
                        required
                        ref={(el) => (frmRef.current["final_temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PreCoolingForm;
